export type TAlertType = 'red' | 'yellow' | 'green';

export type TMonitoringParameter = {
    unit?: string;
    threshold_type?: 'high' | 'low';
    upper_min_limit?: number;
    lower_min_limit?: number;
    name?: string;
};

export type TThresholdType =
    | 'high'
    | 'low'
    | 'high_low'
    | 'boolean'
    | 'weight_variation_percentage';

export const THRESHOLD_TYPE = {
    HIGH: 'high',
    LOW: 'low',
    HIGH_LOW: 'high_low',
    BOOLEAN: 'boolean',
    WEIGHT_VARIATION_PERCENTAGE: 'weight_variation_percentage',
} as const satisfies Record<string, TThresholdType>;

export interface IAlertDetail {
    monitoring_parameter_name: string;
    alert_type: TAlertType;
    threshold_type: TThresholdType;
    monitoring_parameter?: TMonitoringParameter;
}

export type TAlertDetail = {
    monitoringParameterName: string;
    alertType: TAlertType;
    thresholdType: TThresholdType;
};

export type TMeasurementAlert = {
    vitalParameterName: string;
    alertDetails: TAlertDetail[];
};